/* ============================================================
   KKS v2 interactions — reveal, count-up, hover styles,
   FAQ accordion, mobile menu, marquee pause.
   Reimplements the design-canvas directives:
     data-reveal="<ms delay>"          -> fade/slide up on scroll
     data-count="<n>" data-suffix data-dec -> count-up
     data-hover="prop:val; prop:val"   -> apply styles on hover
   ============================================================ */
(function () {
  if (window.__kksLoaded) return;   /* guard: kks-base may be rendered by many sections */
  window.__kksLoaded = true;
  document.documentElement.classList.add('kks-js');

  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- scroll reveal ---------- */
    var reveals = document.querySelectorAll('.kks [data-reveal], .kks-header [data-reveal], .kks-footer [data-reveal]');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var d = parseInt(e.target.getAttribute('data-reveal'), 10);
            e.target.style.transitionDelay = (isNaN(d) ? 0 : d) + 'ms';
            e.target.classList.add('kks-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('kks-in'); });
    }

    /* ---------- count-up ---------- */
    document.querySelectorAll('.kks [data-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-count'));
      if (isNaN(target)) return;
      var suffix = el.getAttribute('data-suffix') || '';
      var dec = parseInt(el.getAttribute('data-dec'), 10) || 0;
      var useComma = target >= 1000;
      function fmt(v) {
        var s = dec ? v.toFixed(dec) : String(Math.round(v));
        if (useComma) s = Number(s).toLocaleString('en-US');
        return s + suffix;
      }
      if (reduce) { el.textContent = fmt(target); return; }
      var done = false;
      var so = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !done) {
            done = true;
            var start = null, dur = 1500;
            (function step(ts) {
              if (!start) start = ts;
              var p = Math.min((ts - start) / dur, 1);
              var eased = 1 - Math.pow(1 - p, 3);
              el.textContent = fmt(target * eased);
              if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target);
            })();
            so.unobserve(e.target);
          }
        });
      }, { threshold: 0.6 });
      so.observe(el);
    });

    /* ---------- hover styles (data-hover) ---------- */
    document.querySelectorAll('.kks [data-hover], .kks-header [data-hover], .kks-footer [data-hover]').forEach(function (el) {
      var decls = el.getAttribute('data-hover').split(';').map(function (s) { return s.trim(); }).filter(Boolean);
      var parsed = decls.map(function (d) {
        var i = d.indexOf(':');
        return { prop: d.slice(0, i).trim(), val: d.slice(i + 1).trim() };
      });
      var original = {};
      el.addEventListener('mouseenter', function () {
        parsed.forEach(function (p) {
          original[p.prop] = el.style.getPropertyValue(p.prop);
          el.style.setProperty(p.prop, p.val);
        });
      });
      el.addEventListener('mouseleave', function () {
        parsed.forEach(function (p) { el.style.setProperty(p.prop, original[p.prop] || ''); });
      });
    });

    /* ---------- FAQ accordion ---------- */
    document.querySelectorAll('.kks-faq-item .kks-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.kks-faq-item');
        item.classList.toggle('kks-open');
        btn.setAttribute('aria-expanded', item.classList.contains('kks-open'));
      });
    });

    /* ---------- mobile menu toggle ---------- */
    document.querySelectorAll('.kks-burger').forEach(function (b) {
      b.addEventListener('click', function () {
        var nav = document.getElementById(b.getAttribute('aria-controls'));
        if (nav) {
          nav.classList.toggle('kks-open');
          b.setAttribute('aria-expanded', nav.classList.contains('kks-open'));
        }
      });
    });

    /* ---------- cursor glow on cards ---------- */
    if (!reduce && window.matchMedia && window.matchMedia('(pointer:fine)').matches) {
      document.querySelectorAll('.kks-glow').forEach(function (card) {
        card.addEventListener('mousemove', function (e) {
          var r = card.getBoundingClientRect();
          card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
          card.style.setProperty('--my', (e.clientY - r.top) + 'px');
        });
      });
    }

    /* ---------- sliders (autoplay + drag/grab + dots + arrows) ---------- */
    document.querySelectorAll('.kks-slider').forEach(function (slider) {
      var track = slider.querySelector('.kks-slider-track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length <= 1) return;
      var index = 0;
      var autoplayMs = parseInt(slider.getAttribute('data-autoplay'), 10) || 0;
      var timer = null;

      var dotsWrap = slider.querySelector('.kks-slider-dots');
      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var d = document.createElement('button');
          d.className = 'kks-dot';
          d.type = 'button';
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.addEventListener('click', function () { go(i); restart(); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }

      function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        dots.forEach(function (d, di) { d.classList.toggle('kks-dot-active', di === index); });
      }
      function next() { go(index + 1); }
      function start() { if (autoplayMs && !reduce) { timer = setInterval(next, autoplayMs); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }

      var prevBtn = slider.querySelector('[data-slider-prev]');
      var nextBtn = slider.querySelector('[data-slider-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); restart(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); restart(); });

      /* drag / grab */
      var startX = 0, dx = 0, dragging = false;
      track.addEventListener('pointerdown', function (e) {
        dragging = true; startX = e.clientX; dx = 0;
        slider.classList.add('kks-grabbing');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        stop();
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        dx = e.clientX - startX;
        track.style.transform = 'translateX(calc(-' + (index * 100) + '% + ' + dx + 'px))';
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        slider.classList.remove('kks-grabbing');
        var w = slider.clientWidth || 1;
        if (dx < -w * 0.15) go(index + 1);
        else if (dx > w * 0.15) go(index - 1);
        else go(index);
        start();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);

      go(0); start();
    });

    /* ---------- mobile slider: dots + autoplay + grab ---------- */
    document.querySelectorAll('.kks-mobile-slider').forEach(function (slider) {
      var kids = slider.children.length;
      if (kids < 2) return;
      var dots = document.createElement('div');
      dots.className = 'kks-mslider-dots';
      for (var k = 0; k < kids; k++) { var d = document.createElement('span'); d.className = 'kks-mdot'; dots.appendChild(d); }
      slider.parentNode.insertBefore(dots, slider.nextSibling);
      var dotEls = dots.querySelectorAll('.kks-mdot');
      var idx = 0;
      var mq = window.matchMedia('(max-width: 760px)');
      function stepW() { var first = slider.firstElementChild; return first ? first.offsetWidth + 14 : slider.clientWidth; }
      function update() {
        idx = Math.round(slider.scrollLeft / stepW());
        if (idx < 0) idx = 0; if (idx > kids - 1) idx = kids - 1;
        for (var j = 0; j < dotEls.length; j++) dotEls[j].classList.toggle('kks-mdot-on', j === idx);
      }
      slider.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
      dotEls.forEach(function (dd, i) { dd.addEventListener('click', function () { slider.scrollTo({ left: i * stepW(), behavior: 'smooth' }); }); });
      update();

      /* autoplay (mobile only) */
      var paused = false, timer = null, resumeT = null;
      function tick() { if (paused || !mq.matches || reduce) return; var n = (idx + 1) % kids; slider.scrollTo({ left: n * stepW(), behavior: 'smooth' }); }
      function pause() { paused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, 6000); }
      ['touchstart', 'wheel', 'mousedown'].forEach(function (ev) { slider.addEventListener(ev, pause, { passive: true }); });
      if (!reduce) timer = setInterval(tick, 4000);

      /* grab / drag with mouse */
      var down = false, sx = 0, sl = 0, moved = false;
      slider.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = slider.scrollLeft; slider.style.cursor = 'grabbing'; pause();
      });
      slider.addEventListener('pointermove', function (e) {
        if (!down) return; if (Math.abs(e.clientX - sx) > 4) moved = true;
        slider.scrollLeft = sl - (e.clientX - sx);
      });
      function endDrag() { if (!down) return; down = false; slider.style.cursor = ''; }
      slider.addEventListener('pointerup', endDrag);
      slider.addEventListener('pointerleave', endDrag);
      slider.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });

    /* ---------- review rails: continuous auto-scroll + drag/grab ---------- */
    document.querySelectorAll('.kks-rail').forEach(function (rail) {
      var track = rail.querySelector('.kks-rail-track');
      if (!track) return;
      var dirRight = rail.getAttribute('data-dir') === 'right';
      var speed = parseFloat(rail.getAttribute('data-speed')) || 0.5;
      // The track holds the blocks rendered twice. The exact seamless loop
      // distance is the start of the second copy (one full set + the gap that
      // follows it) — NOT scrollWidth/2, which is off by half a gap and causes
      // a visible jump on every wrap.
      var half = 0;
      function measure() {
        var kids = track.children, n = kids.length / 2;
        half = (n >= 1 && kids[n]) ? (kids[n].offsetLeft - kids[0].offsetLeft) : track.scrollWidth / 2;
      }
      measure();
      if (!half) return;
      var offset = dirRight ? half : 0;
      var paused = false, dragging = false, startX = 0, startOffset = 0, moved = false;
      function norm() { if (offset >= half) offset -= half; else if (offset < 0) offset += half; }
      function apply() { track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)'; }
      // Time-based motion: keep the original ~speed-px-per-60fps-frame feel, but
      // drive it by elapsed time so it stays smooth on 120Hz / variable-refresh
      // displays and after any dropped frame. dt is clamped so re-focusing the
      // tab can't cause a big jump.
      var pxPerMs = speed * 0.06, last = 0;
      function step(ts) {
        if (!last) last = ts;
        var dt = ts - last; last = ts;
        if (dt > 50) dt = 50;
        if (!paused && !dragging) { offset += (dirRight ? -1 : 1) * pxPerMs * dt; norm(); apply(); }
        requestAnimationFrame(step);
      }
      // Re-measure once images/fonts have settled and on resize (card widths
      // change at the mobile breakpoint), preserving the relative position.
      function remeasure() { var prev = half; measure(); if (prev && half) { offset = offset / prev * half; } norm(); apply(); }
      window.addEventListener('load', remeasure);
      window.addEventListener('resize', remeasure);
      if (reduce) { offset = 0; apply(); }
      else { apply(); requestAnimationFrame(step); }
      rail.addEventListener('mouseenter', function () { paused = true; });
      rail.addEventListener('mouseleave', function () { paused = false; });
      track.addEventListener('pointerdown', function (e) {
        dragging = true; moved = false; startX = e.clientX; startOffset = offset;
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        // Only start a real drag (and capture the pointer) once movement passes the
        // threshold. Capturing on pointerdown re-targets the synthetic click to the
        // track, so plain taps/clicks on a card never navigate to the product page.
        if (!moved && Math.abs(e.clientX - startX) > 6) {
          moved = true;
          rail.classList.add('kks-grabbing');
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (!moved) return;
        offset = startOffset - (e.clientX - startX); norm(); apply();
      });
      function endDrag() { if (!dragging) return; dragging = false; rail.classList.remove('kks-grabbing'); }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });

    /* ---------- YouTube click-to-play embeds ---------- */
    document.querySelectorAll('.kks-yt-embed').forEach(function (el) {
      function play() {
        var id = el.getAttribute('data-yt');
        if (!id) return;
        var ifr = document.createElement('iframe');
        ifr.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        ifr.title = 'YouTube video player';
        ifr.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        ifr.setAttribute('allowfullscreen', '');
        ifr.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
        el.innerHTML = '';
        el.appendChild(ifr);
      }
      el.addEventListener('click', play);
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); } });
    });
  }

  /* ---------- Ryezing trial CTA conversion tracking ----------
     Any link to enroll.ryezing.com fires a 'start_trial_click' event to
     dataLayer (GTM), GA4 (gtag) and Meta Pixel (fbq) — wherever present.
     Bound once at document level so it also catches cloned/rail slides. */
  if (!window.__kksTrialTracked) {
    window.__kksTrialTracked = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('enroll.ryezing.com') === -1) return;
      var label = (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'start_trial_click', link_url: href, link_text: label, page_location: location.href });
      } catch (_) {}
      try { if (typeof gtag === 'function') gtag('event', 'start_trial_click', { link_url: href, link_text: label }); } catch (_) {}
      try { if (typeof fbq === 'function') fbq('track', 'Lead', { content_name: 'Ryezing $1 Trial' }); } catch (_) {}
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
